import React, { useState } from "react";
import { Card, Typography, Row, Col, Space, Divider, Avatar, message,Table } from "antd";
import { QuestionCircleOutlined, UserOutlined, EditOutlined } from "@ant-design/icons";
import { routes } from "../../routes/Routes";
import { useHistory } from "react-router-dom";
import _NewapplicationService from "../../modules/NewapplicationService";
import _commonService from "../../modules/commonService";
import "./PreviewGeneralInfo.scss"
const { Text, Title } = Typography;

const PreviewGeneralInfo = ({ applnObjId, applicantInfo, applicantFundInfo }) => {
  const history = useHistory();
  const [applicationObjId] = useState(applnObjId);

  // const editApplicantInfo = () => {
  //   history.push({
  //     pathname: routes.ApplicantsDetails.path,
  //     state: { applicationObjId: applicationObjId || localStorage.getItem("ApplicationObjId"), isFromDashboard: true },
  //   });
  // }

  return (
    <Card
      bordered={false}
      className="cardBodyPadding card-section"
    >
      {/* Header Row */}
      <Row justify="space-between" align="middle">
        <Space>
          {/* <Avatar icon={} size="small" /> */}
          <Text strong><UserOutlined /> Personal Details</Text>
        </Space>
        {/* <EditOutlined className="editIconClass" onClick={editApplicantInfo} style={{ color: "#595959", cursor: "pointer" }} /> */}
      </Row>

      <Divider style={{ margin: '12px 0' }} />

      {/* Applicant Type */}
      {/* <Row justify={"space-between"} gutter={8}>

        <Col>
          <Text strong style={{ fontSize: 14 }}>Application Type</Text><br />
          <Text style={{ fontSize: 13 }}>{applicantInfo && applicantInfo.ApplicantType}</Text>
        </Col>
        <Col>
          <Avatar icon={<UserOutlined />} size="small" />
        </Col>
      </Row> */}

      {/* Info List */}
      <div className="Apppara">
        {[
          { label: "First Name", value: applicantInfo && applicantInfo.FirstName || "N/A" },
          { label: "Last Name", value: applicantInfo && applicantInfo.LastName || "N/A" },
          { label: "Date Of Birth", value: applicantInfo && applicantInfo.DateOfBirth ? _commonService.convertToMMDDYYYY(applicantInfo.DateOfBirth) : "N/A" },
          { label: "Contact No.", value: applicantInfo && applicantInfo.Phone ? _commonService.formatUSPhoneNumber(applicantInfo.Phone) : "N/A" },
          { label: "Email", value: applicantInfo && applicantInfo.Email || "N/A" },
          { label: "City", value: applicantInfo && applicantInfo.City || "N/A" },
        ].map((item) => (
          <Row key={item.label}>
            <Col span={24}>
              <Text type="secondary">{item.label} :</Text>
            </Col>
            <Col span={24}>
              <Text>{item.value}</Text>
            </Col>
          </Row>
        ))}
      </div>

      <Divider style={{ margin: '12px 0' }} />

      {/* Loan Inquiry */}
      <Row className="loan-amount-container">
        {/* <Avatar
            icon={<QuestionCircleOutlined />}
            size="small"

          /> */}
        <Text strong className="loan-title">Requested Loan Amount :</Text>
        <Text className="loan-value">{applicantInfo && applicantInfo.LoanEnquiryFor ? `$ ${_commonService.formatNumberWithCommas(applicantInfo.LoanEnquiryFor)}` : "N/A"}</Text>
      </Row>

      {applicantFundInfo?.length > 0 && (
        <>
          <Divider />
          <div className="lh-section-title">Fund Details</div>
          <Table
            dataSource={applicantFundInfo}
            rowKey="Id"
            pagination={false}
            size="small"
            className="transparent-table"
            scroll={{ x: true }}
            columns={[
              { title: "Fund Name", dataIndex: "FundName", key: "FundName" },
              {
                title: "Fund Value",
                dataIndex: "FundValue",
                key: "FundValue",
                render: (val) => val ? `$${_commonService.formatNumberWithCommas(val)}` : "N/A",
              },
              { title: "Vintage Year", dataIndex: "VintageYear", key: "VintageYear" },
              { title: "Asset Class", dataIndex: "AssetClassType", key: "AssetClassType" },
            ]}
          />
        </>
      )}



    </Card>
  )
}
export default PreviewGeneralInfo;